import { websiteIcon } from "./icon-catalogue";

/** Trusted local SVG subset; never parses customer-supplied SVG or downloads an icon font. */
export default function WebsiteIcon({
  name,
  className = "inline-block size-4 shrink-0",
  style,
  cardArrow = false,
}: {
  name?: unknown;
  className?: string;
  style?: React.CSSProperties;
  /** The arrow a look-system card nudges (src/styles/motion.css). */
  cardArrow?: boolean;
}) {
  const icon = websiteIcon(name);
  return icon ? (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox={icon.viewBox}
      className={className}
      style={style}
      data-re-card-arrow={cardArrow ? "" : undefined}
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      {icon.paths.map((path, index) => (
        <path key={index} d={path} />
      ))}
    </svg>
  ) : null;
}
